import { fromLonLat } from 'ol/proj';
import Feature from 'ol/Feature';
import { gridLineStyle } from './styles';
import { LineString } from 'ol/geom';
import { GridLineDrawingPropertyDto } from 'models/mooring';
import VectorSource from 'ol/source/Vector';
import { BuoyMappedForDrawing } from '../buoy';
import { mapFeature, MapRenderOptions } from '../renderOptions';
import { calculateLineConnections } from './transform';

type RenderGridLinesProps = {
  grid: BuoyMappedForDrawing[][];
  gridLines: GridLineDrawingPropertyDto[];
  vectorSource: VectorSource;
};
export const renderGridLines = ({ gridLines, vectorSource, grid }: RenderGridLinesProps, renderOptions: MapRenderOptions) => {
  const lines = calculateLineConnections(grid, gridLines);

  if (!lines || lines.length === 0) return;

  const added = new Set<number>();

  for (const line of lines) {
    const gridLine = gridLines.find((l) => l.Id === line.Id);

    const hasLinesWithSameBuoys = gridLines.filter(
      (l) =>
        ((l.FromBuoyId === gridLine.FromBuoyId && l.ToBuoyId === gridLine.ToBuoyId) ||
          (l.FromBuoyId === gridLine.ToBuoyId && l.ToBuoyId === gridLine.FromBuoyId)) &&
        l.Id !== gridLine.Id
    );

    const lineFeature = new Feature({
      geometry: new LineString([fromLonLat(line.Start), fromLonLat(line.End)]),
      type: mapFeature.gridLine,
      id: line.Id,
    });

    const label = line.AnalysisNo ?? '';

    lineFeature.setStyle((_, res) => gridLineStyle(label, line.IsAccident, hasLinesWithSameBuoys.length + 1, res));

    vectorSource.addFeature(lineFeature);

    added.add(line.Id);
  }
};
